export const getNumberInputWidth = (inputValue: number) => {
  const inputLength = inputValue?.toString().length;
  const width = inputLength > 3 ? inputLength * 0.9 : 3;
  return `${width + 5}ch`;
};
